var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.cell.isErrorsCell
    ? _c("label", { class: _vm.question.getItemLabelCss(_vm.item) }, [
        _c(
          "span",
          {
            class: _vm.question.getItemTitleCss(),
            style: {
              minWidth: _vm.question.itemTitleWidth,
              width: _vm.question.itemTitleWidth,
            },
          },
          [
            _vm.item.editor.isRequireTextBeforeTitle ||
            _vm.item.editor.isRequireTextOnStart
              ? _c("span", { class: _vm.question.cssClasses.requiredText }, [
                  _vm._v(_vm._s(_vm.item.editor.requiredText)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("survey-string", { attrs: { locString: _vm.item.locTitle } }),
            _vm._v(" "),
            _vm.item.editor.isRequireTextAfterTitle
              ? _c("span", [_vm._v(" ")])
              : _vm._e(),
            _vm._v(" "),
            _vm.item.editor.isRequireTextAfterTitle
              ? _c(
                  "span",
                  {
                    class: _vm.question.cssClasses.requiredText,
                    attrs: { "aria-hidden": "true" },
                  },
                  [_vm._v(_vm._s(_vm.item.editor.requiredText))]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            key: _vm.item.editor.id,
            class: _vm.question.getItemCss(),
            on: {
              focusin: function ($event) {
                return _vm.item.focusIn()
              },
            },
          },
          [
            _c(_vm.getComponentName(_vm.item.editor), {
              tag: "component",
              attrs: { question: _vm.item.editor },
            }),
          ],
          1
        ),
      ])
    : _c("survey-errors", { attrs: { element: _vm.item.editor } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }